import React from "react";
import { Button, Card, Stack, Text } from "@chaser/components";
import { ChartNoAxesColumn } from "lucide-react";
import { useHistory } from "react-router-dom";
import PageContainer from "../../../components/PageContainer";
import LoadingMessage from "../../../components/LoadingMessage";
import useReceivablesForecastTrial from "../../../hooks/useReceivablesForecastTrial";
import screenshotImg from "../../../assets/receivables-forecast/ar_forecasting_page.png";
import styles from "./ReceivablesForecastTease.module.scss";

const ReceivablesForecastTease = ({
  isTrialExpired,
  isSubscriber,
  isChaserTrial,
}) => {
  const { startTrial, loading, requestAddon, requesting } =
    useReceivablesForecastTrial();
  const router = useHistory();
  const handleActivateAddon = () => {
    router.push("/settings/subscription/addons");
  };

  return (
    <PageContainer>
      <div className={styles.wrapper}>
        <div className={styles.background}>
          <img
            className={styles.screenshot}
            src={screenshotImg}
            alt=""
            aria-hidden="true"
          />
        </div>
        <div className={styles.overlay} />
        <div className={styles.ctaContainer}>
          <Card p={0} className={styles.ctaCard}>
            <Stack alignItems="center" gap="small" className={styles.cardBody}>
              <div className={styles.iconCircle}>
                <ChartNoAxesColumn size={24} strokeWidth={2.5} />
              </div>
              {isTrialExpired ? (
                <>
                  <Text
                    as="h2"
                    fontSize="large"
                    fontWeight="bold"
                    className={styles.heading}
                  >
                    Your trial has expired
                  </Text>
                  <Text as="p">
                    {isSubscriber
                      ? "You'll be redirected to the add-ons page to complete this purchase."
                      : "Only subscribing users can activate add-ons. You can request your subscribing users to activate the add-on by clicking the button below."}
                  </Text>
                </>
              ) : (
                <>
                  <Text
                    as="h2"
                    fontSize="large"
                    fontWeight="bold"
                    className={styles.heading}
                  >
                    Predict your incoming revenue
                  </Text>
                  <Text as="p">
                    Get a <strong>30-day free trial.</strong> See exactly when
                    your customers are likely to pay and identify collection
                    risks before they happen. No credit card or subscriber
                    approval is needed to start.
                  </Text>
                </>
              )}
            </Stack>
            <hr className={styles.divider} />
            <div className={styles.cardFooter}>
              {isTrialExpired ? (
                isSubscriber ? (
                  <Button onClick={handleActivateAddon}>Activate add-on</Button>
                ) : (
                  <Button onClick={requestAddon} disabled={requesting}>
                    {requesting ? "Sending..." : "Request add-on"}
                  </Button>
                )
              ) : loading ? (
                <LoadingMessage />
              ) : (
                <Button onClick={startTrial}>Start forecasting now</Button>
              )}
            </div>
          </Card>
        </div>
      </div>
    </PageContainer>
  );
};

export default ReceivablesForecastTease;
